import React, { useRef, useEffect } from 'react';

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export default function LyricDisplay({ lyrics, currentLyricIndex, currentLyric, nextLyric, isPlaying }) {
  const activeRef = useRef(null);
  const scrollRef = useRef(null);

  // Auto-scroll to active lyric
  useEffect(() => {
    if (activeRef.current && scrollRef.current) {
      activeRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [currentLyricIndex]);

  // Get previous lyric for context
  const prevLyric = currentLyricIndex > 0 ? lyrics[currentLyricIndex - 1] : null;

  return (
    <div className="lyric-display">
      {/* Main lyric spotlight */}
      <div className="lyric-stage">
        {/* Previous lyric (upcoming was last) */}
        {prevLyric && (
          <div className="lyric-upcoming">{prevLyric.text}</div>
        )}

        {/* Current lyric - BIG CENTER */}
        <div className={`lyric-current ${currentLyric?.text ? 'has-text' : ''}`}>
          {currentLyric?.text || (
            <span className="lyric-empty">
              {lyrics.length === 0 ? '♪ No lyrics available ♪' : isPlaying ? '♪' : 'Press play to begin'}
            </span>
          )}
        </div>

        {/* Next lyric preview */}
        {nextLyric && (
          <div className="lyric-next">{nextLyric.text}</div>
        )}

        {/* Animated background bars when playing */}
        {isPlaying && currentLyric && (
          <div className="waveform" style={{ position: 'absolute', bottom: 16, opacity: 0.4 }}>
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className="wave-bar"
                style={{
                  '--dur': `${0.4 + (i % 4) * 0.15}s`,
                  '--delay': `${i * 0.06}s`,
                  '--peak': `${12 + Math.random() * 20}px`,
                  height: `${6 + Math.random() * 20}px`,
                }}
              />
            ))}
          </div>
        )}
      </div>

      {/* Scrollable lyrics list */}
      {lyrics.length > 0 && (
        <div className="lyric-scroll-container" ref={scrollRef}>
          {lyrics.map((lyric, i) => (
            <div
              key={lyric.id || i}
              className={`lyric-scroll-line ${i === currentLyricIndex ? 'active' : ''}`}
              ref={i === currentLyricIndex ? activeRef : null}
            >
              <span className="lyric-timestamp">{formatTime(lyric.startTime)}</span>
              <span>{lyric.text}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
